import { render, staticRenderFns } from "./JiaoCheng.vue?vue&type=template&id=4763cf1f&scoped=true&"
import script from "./JiaoCheng.vue?vue&type=script&lang=js&"
export * from "./JiaoCheng.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4763cf1f",
  null
  
)

export default component.exports